import { createElement } from 'react';

import {
  ApiBlueprint,
  SubPageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';

import { ApiKeysClient, apiKeysApiRef } from './api';

const apiKeysApi = ApiBlueprint.make({
  name: 'api-keys',
  params: defineParams =>
    defineParams({
      api: apiKeysApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ApiKeysClient({ discoveryApi, fetchApi }),
    }),
});

/**
 * `SubPageBlueprint` attaches to the page of its own plugin by default, so the
 * settings page has to be named explicitly.
 */
const apiKeysSettingsPage = SubPageBlueprint.make({
  name: 'api-keys',
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: 'api-keys',
    title: 'API Keys',
    loader: async () => {
      const { ApiKeysSettingsPage } = await import(
        './components/ApiKeysSettingsPage'
      );
      return createElement(ApiKeysSettingsPage);
    },
  },
});

export const apiKeysPlugin = createFrontendPlugin({
  pluginId: 'api-keys-frontend',
  extensions: [apiKeysApi, apiKeysSettingsPage],
});
